import { render, staticRenderFns } from "./AuthOverlay.vue?vue&type=template&id=7a6d1c95"
import script from "./AuthOverlay.vue?vue&type=script&lang=js"
export * from "./AuthOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports